import { render, staticRenderFns } from "./our-totality.vue?vue&type=template&id=4f03a754&"
import script from "./our-totality.vue?vue&type=script&lang=js&"
export * from "./our-totality.vue?vue&type=script&lang=js&"
import style0 from "./our-totality.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports